<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="500px"
    @close="handleClose"
  >
    <el-form 
      ref="tenantForm" 
      :model="form" 
      :rules="rules" 
      label-width="100px"
    >
      <el-form-item label="公司名称：" prop="tenantname">
        <el-input
          v-model="form.tenantname"
          placeholder="请输入公司名称"
          clearable
        />
      </el-form-item>
      
      <el-form-item label="联系人：" prop="contact">
        <el-input
          v-model="form.contact"
          placeholder="请输入联系人"
          clearable
        />
      </el-form-item>
      
      <el-form-item label="联系电话：" prop="contactphone">
        <el-input
          v-model="form.contactphone"
          placeholder="请输入联系电话"
          clearable
        />
      </el-form-item>
    </el-form>
    
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading">
        确定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "TenantEditDialog",
  
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => ({})
    }
  },
  
  // ✅ 正确：data 必须是一个函数，返回一个对象
  data() {
    return {
      form: {
        tenantid: '',
        tenantname: '',
        contact: '',
        contactphone: ''
      },
      rules: {
        tenantname: [
          { required: true, message: '请输入公司名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        contact: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        contactphone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ]
      },
      loading: false,
      dialogTitle: '编辑租户信息'
    }
  },
  
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    }
  },
  
  watch: {
    visible(newVal) {
      if (newVal && this.formData) {
        this.form = {
          tenantid: this.formData.tenantid || '',
          tenantname: this.formData.tenantname || '',
          contact: this.formData.contact || '',
          contactphone: this.formData.contactphone || ''
        };
        
        if (this.$refs.tenantForm) {
          this.$refs.tenantForm.clearValidate();
        }
      }
    }
  },
  
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.$emit('close');
    },
    
    handleSubmit() {
      this.$refs.tenantForm.validate(valid => {
        if (valid) {
          this.loading = true;
          
          // 触发保存事件，将表单数据传递给父组件
          this.$emit('save', { ...this.form });
          
          // 模拟异步操作
          setTimeout(() => {
            this.loading = false;
            this.handleClose();
          }, 500);
        } else {
          this.$message.warning('请正确填写表单');
          return false;
        }
      });
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}

.el-form-item {
  margin-bottom: 20px;
}

.el-input {
  width: 100%;
}
</style>